import React, { useState } from 'react';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from '@mui/material';

import {ViewershipInfoContent} from "./ViewershipInfoContent";

export default function ViewershipInfoDialogue({open, onClose, selectorContractGridAPI
                                        }) {

    const handleCloseInfo = () => {
        onClose(true);
    };

    const info = ViewershipInfoContent(selectorContractGridAPI);

    return (
        <>

            <Dialog
                open={open}
                onClose={onClose}
            >

                <DialogTitle>
                    {info.title}
                </DialogTitle>

                <DialogContent>
                    {info.content}
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseInfo}>
                        Close
                    </Button>
                </DialogActions>

            </Dialog>

        </>
    );
}